import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    Construccion_1,
    Construccion_2,
    Construccion_3,
    Construccion_4,
    Construccion_5,
    Construccion_6,
} from '../../../assets/images';

const Construccion = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const images = [
        Construccion_1,
        Construccion_2,
        Construccion_3,
        Construccion_4,
        Construccion_6,
        Construccion_5,
    ];

    const nextImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    };

    const prevImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    const features = [
        {
            title: 'Tradición desde 1945',
            description: 'Joseph Cyril Bamford comenzó a utilizar su estilo de ingeniería y pensamiento innovador para inventar nuevos equipos de construcción.'
        },
        {
            title: 'Revolución en 1953',
            description: 'La retroexcavadora JCB revolucionó la industria de la construcción, estableciendo nuevos estándares de versatilidad y rendimiento.'
        },
        {
            title: 'Líderes Mundiales',
            description: 'Somos el líder mundial del mercado de retroexcavadoras y manipuladores telescópicos.'
        },
        {
            title: 'Amplia Gama',
            description: 'Contamos con una gama de más de 300 máquinas que operan en seis continentes.'
        },
        {
            title: 'Innovación Constante',
            description: 'Siempre buscando un mejor camino, superando continuamente nuestros límites gracias a nuestro deseo de ser los mejores.'
        },
        {
            title: 'Soporte Integral',
            description: 'Estaremos allí para apoyar a nuestros clientes en cada paso del camino para cumplir con nuevos estándares y legislación.'
        }
    ];

    return (
        <div className="container mx-auto px-6 py-24">
            <nav className="text-sm mb-8">
                <Link to="/" className="text-text-muted hover:text-dark-primary">Inicio</Link>
                <span className="mx-2 text-text-muted">/</span>
                <Link to="/industries" className="text-text-muted hover:text-dark-primary">Industrias</Link>
                <span className="mx-2 text-text-muted">/</span>
                <span className="text-dark-primary font-medium">Construcción</span>
            </nav>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start mb-16">
                <div>
                    <h1 className="text-4xl md:text-5xl font-display font-bold text-dark-primary mb-2">
                        Construcción
                    </h1>
                    <p className="text-text-muted text-lg mb-6">
                        En 1945, Joseph Cyril Bamford comenzó a utilizar su estilo de ingeniería y su pensamiento innovador para inventar 
                        nuevos equipos de construcción. En 1953, la retroexcavadora JCB revolucionó la industria de la construcción. 
                        Hoy contamos con una gama de más de 300 máquinas que operan en seis continentes y somos el líder mundial del 
                        mercado de retroexcavadoras y manipuladores telescópicos.
                    </p>
                    <Link
                        to="/contact"
                        className="inline-flex items-center justify-center font-display text-xs uppercase tracking-luxury font-medium bg-dark-primary text-white hover:bg-black px-8 py-3 rounded-none transition-all duration-300"
                    >
                        Solicitar información
                    </Link>
                </div>
                <div className="relative">
                    <div className="bg-surface-subtle aspect-video rounded-lg flex items-center justify-center overflow-hidden relative">
                        <img
                            src={images[currentImageIndex]}
                            alt="Construcción"
                            className="w-full h-full object-cover transition-opacity duration-300"
                        />
                        {images.length > 1 && (
                            <>
                                <button
                                    onClick={prevImage}
                                    className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                    </svg>
                                </button>
                                <button
                                    onClick={nextImage}
                                    className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </button>
                                <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2">
                                    {images.map((_, index) => (
                                        <button
                                            key={index}
                                            onClick={() => setCurrentImageIndex(index)}
                                            className={`w-2 h-2 rounded-full transition-all ${currentImageIndex === index ? 'bg-white w-4' : 'bg-white/50'}`}
                                        />
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                    {images.length > 1 && (
                        <p className="text-center text-sm text-text-muted mt-2">
                            {currentImageIndex + 1} / {images.length}
                        </p>
                    )}
                </div>
            </div>

            <div className="mb-16">
                <h2 className="text-2xl font-display font-bold text-dark-primary mb-8">
                    Características Destacadas
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {features.map((feature, index) => (
                        <div key={index} className="p-6 bg-white border border-border-subtle hover:shadow-md transition-shadow">
                            <h3 className="font-display font-semibold text-dark-primary text-lg mb-2">
                                {feature.title}
                            </h3>
                            <p className="text-text-muted text-sm">
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="bg-surface-subtle p-8 md:p-12 text-center">
                <h2 className="text-2xl font-display font-bold text-dark-primary mb-4">
                    ¿Interesado en soluciones para construcción?
                </h2>
                <p className="text-text-muted mb-6 max-w-2xl mx-auto">
                    Contáctanos para obtener más información, cotizaciones o asesoría técnica sobre nuestras soluciones para el sector construcción.
                </p>
                <Link
                    to="/contact"
                    className="inline-flex items-center justify-center font-display text-xs uppercase tracking-luxury font-medium bg-dark-primary text-white hover:bg-black px-8 py-3 transition-all duration-300"
                >
                    Solicitar cotización
                </Link>
            </div>
        </div>
    );
};

export default Construccion;